module.exports = "\r\n<menu-left></menu-left>\r\n\r\n\r\n<router-outlet>\r\n\r\n</router-outlet> \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/layouts/layouts.component.html
// module id = ./src/app/components/layouts/layouts.component.html
// module chunks = main